import { EMPTY_ARRAY } from 'data/global';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';
import {
  includesIgnoreCase,
  getUserFullNameOrEmail,
  getArrayLength,
  getHasElementsInArray,
} from 'utils';

export const filterMembers = (members: DataRoomMember[], search: string) =>
  search
    ? members.filter((member) =>
        includesIgnoreCase(getUserFullNameOrEmail(member), search),
      )
    : members;

export const getGroupSelectionState = (
  members: DataRoomMember[] = EMPTY_ARRAY,
  selectedIds: string[] = EMPTY_ARRAY,
) => {
  const selectedCount = getArrayLength(
    members.filter(({ _id }) => selectedIds.includes(_id)),
  );

  const allSelected =
    getHasElementsInArray(members) && selectedCount === getArrayLength(members);

  return { allSelected, mixed: selectedCount > 0 && !allSelected };
};
